import { Link } from "react-router-dom";
import { Truck, ShieldCheck, Headphones } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-ink text-white mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 grid grid-cols-1 sm:grid-cols-3 gap-6 border-b border-white/10">
        <div className="flex items-center gap-3">
          <Truck size={24} className="text-brand" />
          <span className="text-sm">Shipped to NZ, AU & worldwide · Free over $75 (NZ & AU)</span>
        </div>
        <div className="flex items-center gap-3">
          <ShieldCheck size={24} className="text-brand" />
          <span className="text-sm">Secure checkout · GST handled for NZ & AU</span>
        </div>
        <div className="flex items-center gap-3">
          <Headphones size={24} className="text-brand" />
          <span className="text-sm">AI concierge + human support, 7 days</span>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-baseline gap-1 mb-4">
            <span className="font-display font-black text-2xl tracking-tighter">GO</span>
            <span className="font-display font-black text-2xl tracking-tighter text-brand">BIG</span>
            <span className="font-display font-black text-2xl tracking-tighter">FOREVER</span>
          </div>
          <p className="text-sm text-white/60 leading-relaxed">
            Premium best-sellers for New Zealand & Australia. Founded and led by CEO W. Johnson.
          </p>
        </div>
        <div>
          <h4 className="overline mb-4">Shop</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/shop" className="hover:text-brand">All products</Link></li>
            <li><Link to="/shop" className="hover:text-brand">Best sellers</Link></li>
            <li><Link to="/cart" className="hover:text-brand">Cart</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="overline mb-4">Help</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/track" className="hover:text-brand">Track order</Link></li>
            <li><Link to="/shipping-returns" className="hover:text-brand" data-testid="footer-shipping-link">Shipping & returns</Link></li>
            <li><Link to="/faq" className="hover:text-brand" data-testid="footer-faq-link">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-brand">Contact us</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="overline mb-4">Get in touch</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a href="mailto:support@gobigforever.com" className="hover:text-brand" data-testid="footer-email-link">support@gobigforever.com</a></li>
            <li><Link to="/contact" className="hover:text-brand">Message us anytime</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Go Big Forever. All rights reserved. ABN 13 957 863 564.
      </div>
    </footer>
  );
}
